import { render } from "./dashboardView.vue?vue&type=template&id=0d572688&scoped=true"
import script from "./dashboardView.vue?vue&type=script&lang=js"
export * from "./dashboardView.vue?vue&type=script&lang=js"

import "./dashboardView.vue?vue&type=style&index=0&id=0d572688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d572688"]])

export default __exports__